module.exports = __webpack_public_path__ + "media/חיפושית.d1665cd7.mp3";